import request from '@/utils/request'

export const getList = (userId) => {
  return request.get('/file/list', {
    params: {
      userId
    }
  })
}

export const goPay = (id) => {
  return request.put('/pay/submit/20/' + id)
}

export const goDownload = (id) => {
  return request({
    url: '/file/download/' + id,
    method: 'GET',
    responseType: 'blob' // 重要：设置响应类型为blob
  })
}

export const goOtherResourcePay = (id) => {
  return request.put('/pay/submit/21/' + id)
}

export const getOtherResourcePage = (userId, name, type, current, size) => {
  return request.get('/otherResource/page', {
    params: {
      userId,
      name,
      type,
      current,
      size
    }
  })
}
